import { useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { Get, Set } from "../../../../../Request";

export const useContract = (form, setform, reserve = false) => {
  const [loading, setLoading] = useState({ check: false });
  const {
    user: { item },
  } = useSelector(state => state);

  const isInArray = (timekey, dayname) => {
    let res = false;
    form.times &&
      form.times.map(element => {
        if (element.timekey == timekey && element.dayname == dayname) {
          res = true;
        }
      });
    return res;
  };
  const removeTime = (timekey, dayname) => {
    setform({
      ...form,
      times: [...form.times].filter(
        element => !(element.timekey == timekey && element.dayname == dayname)
      ),
    });
  };
  const addTime = (timekey, dayname) => {
    setform({ ...form, times: [...form.times, { timekey, dayname }] });
  };
  const toggleSelect = (timekey, dayname) => {
    if (isInArray(timekey, dayname)) {
      removeTime(timekey, dayname);
    } else {
      if (reserve && form.times.length == 2) {
        toast.error("بیشتر از دو سانس قابل انتخاب نیست");
      } else {
        addTime(timekey, dayname);
      }
    }
  };

  const arrLength = () => {
    return form.times.length;
  };
  const checkTimes = async () => {
    setLoading({ ...loading, check: true });
    Get({
      url: "/contractreserve/check_create",
      data: { item_id: item[0].id },
    }).then(res => {
      setLoading({ ...loading, check: false });
    });
  };
  const submit = async () => {
    setLoading({ ...loading, submit: true });
    Set({
      url: "/contractreserve/create",
      data: { item_id: item[0].id },
    }).then(res => {
      setLoading({ ...loading, submit: false });
    });
  };
  const checkDate = async () => {
    setLoading({ ...loading, check: true });
    Get({
      url: "/contractreserve/checkdate",
      data: { item_id: item[0].id },
    }).then(res => {
      setLoading({ ...loading, check: false });
    });
  };
  return {
    toggleSelect,
    arrLength,
    isInArray,
    checkTimes,
    loading,
    checkDate,
    submit,
  };
};
